/*
 * newsbot - forked from autobrr
 */

import { Stats } from "./dashboard/Stats";
import { ActivityTable } from "./dashboard/ActivityTable";
import { FeedHealthTable } from "./dashboard/FeedHealthTable";

export const Dashboard = () => (
  <main aria-label="Dashboard">
    <div className="my-6 max-w-(--breakpoint-xl) mx-auto pb-6 px-4 sm:px-6 lg:pb-16 lg:px-8">
      <Stats />
      <ActivityTable />
      <FeedHealthTable variant="dashboard" />
    </div>
  </main>
);
